import { EmptyState } from '@/components/ui/empty-state'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import {
  activityRetentionLabel,
  type ActivityRetentionYears,
} from './connections/activityRetention'

export interface PlatformConnectionRetentionRow {
  id: number
  display_name: string
  activity_retention_years?: ActivityRetentionYears
}

export function PlatformConnectionRetention({
  connections,
}: {
  connections?: PlatformConnectionRetentionRow[]
}) {
  if (!connections)
    return (
      <div className="mb-6">
        <EmptyState variant="quiet" title="Connection retention details are not available." />
      </div>
    )
  if (!connections.length)
    return (
      <div className="mb-6">
        <EmptyState variant="quiet" title="No Connections" />
      </div>
    )
  return (
    <div className="mb-6 overflow-hidden rounded-md border border-border bg-card">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Connection</TableHead>
            <TableHead>Activity retention</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {connections.map((connection) => (
            <TableRow key={connection.id}>
              <TableCell>{connection.display_name}</TableCell>
              <TableCell>{activityRetentionLabel(connection.activity_retention_years)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
